export const EREQUEST = `EREQUEST`;

/* LAYOUT */

// DETAIL
export const SET_EREQUEST_ID = `${EREQUEST}/SET_EREQUEST_ID`;
